import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TCreateWalkthroughRequest,
  TProposeReschedule,
  TWalkthroughAppointment,
  TWalkthroughList,
  TWalkthroughListParams,
} from './walkthrough.types.ts';

export const walkthroughApi = {
  getMyAppointment: async () => {
    const response = await axios.get<TWalkthroughAppointment | null>(`walkthrough/me`);

    return response.data;
  },
  createRequest: async (request: TCreateWalkthroughRequest) => {
    const response = await axios.post<TWalkthroughAppointment>(`walkthrough/requests`, request);

    return response.data;
  },
  acceptProposal: async (appointmentId: number) => {
    const response = await axios.post<TWalkthroughAppointment>(
      `walkthrough/requests/${appointmentId}/accept`,
    );

    return response.data;
  },
  // Admin
  getAppointments: async (params: TWalkthroughListParams = {}) => {
    const response = await axios.get<TWalkthroughList>(`walkthrough/admin`, { params });

    return response.data;
  },
  confirmAppointment: async ({
    appointmentId,
    confirmed_time,
  }: {
    appointmentId: number;
    confirmed_time?: string;
  }) => {
    const response = await axios.patch<TWalkthroughAppointment>(
      `walkthrough/admin/${appointmentId}/confirm`,
      { confirmed_time },
    );

    return response.data;
  },
  proposeReschedule: async ({
    appointmentId,
    ...proposal
  }: TProposeReschedule & { appointmentId: number }) => {
    const response = await axios.patch<TWalkthroughAppointment>(
      `walkthrough/admin/${appointmentId}/propose`,
      proposal,
    );

    return response.data;
  },
  // Advisor
  getAdvisorAppointments: async (params: TWalkthroughListParams = {}) => {
    const response = await axios.get<TWalkthroughList>(`walkthrough/advisor`, { params });

    return response.data;
  },
  completeAppointment: async (appointmentId: number) => {
    const response = await axios.patch(`walkthrough/admin/${appointmentId}/complete`);

    return response.data;
  },
};

export const walkthroughQueries = createQueryKeys('walkthrough', {
  getMyAppointment: () => ({
    queryKey: ['me'],
    queryFn: walkthroughApi.getMyAppointment,
  }),
  getAppointments: (params: TWalkthroughListParams = {}) => ({
    queryKey: [params],
    queryFn: () => walkthroughApi.getAppointments(params),
  }),
  getAdvisorAppointments: (params: TWalkthroughListParams = {}) => ({
    queryKey: ['advisor', params],
    queryFn: () => walkthroughApi.getAdvisorAppointments(params),
  }),
});
